const $ = require('jquery');
const _ = require("underscore");
import run from '../../utilities/run';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import { createPreventDefault } from '../../utilities/general';
import { isNullOrUndefined, isUndefined } from "util";
import { isBlank } from "../../utilities/general";
import EditChecker from '../../components/EditChecker/EditChecker';


let els = {};
const elsModal = {};
const elsModalMap = {};
const elsMap = {
    dimName: "#dimdivisor-name",
    dimMerchants:"#retailerList",
    dimSaveBtn:".dim-save-btn",
    dimFormElement:"#dimdivisor-create-edit",
    dimValidateClass: ".dim-validate",
    retailersdropdown:".retailer-list-select",
    merchantTierDropDown:".merchant-tier-select",
    merchantDiv:"#merchant-exists",
    tierExistDiv:"#tier-exists",
    dimCancelBtn: "#dim-cancel-btn",
    dimNameExists:"#dim-name-exists",
    dimNameError : "#dim-name-error",
    selectMerchantSwitch : ".select-merchant-switch",
    merchantSection : ".merchant-section",
    merchantTierSection : ".merchant-tier-section"
}

const customValidateProps = {
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  };

const defDimName = "Default - All Merchants";
const defMerchant = "0";
const targetSelector = "#dimdivisor-createedit";


run(targetSelector, (mainEl) => {

    const defaultDim = mainEl.data("defaultdim");
    const editDimMerchantTier = mainEl.data("edit-dim-merchant-tier");
    const retailerCheckUrl = mainEl.data("retailer-code-check-url");
    const marchantTierValuesUrl = mainEl.data("merchant-tier-values-url");
    const portletNamespace = mainEl.data("portlet-namespace");
    const dimNameCheckUrl = mainEl.data("dim-name-check-url");
    const saveDimDivisorUrl = mainEl.data("url");
    const editForm =  mainEl.data("edit-form");
    
   
    function init() {
        generateModals();
        setElementsInModals();
        setElements();
        loadDropDowns();
        bindElements();
        renderDefaultDimUI();
        setupEditChecker();
        setInitialState();
    }

    function setElements() {
        setElementsFromScope(els, elsMap, mainEl);
    }

    function setElementsInModals() {
        const body = $('body');
        setElementsFromScope(elsModal, elsModalMap, body);
    }

    function setInitialState() {
        els.dimFormElement.validate(customValidateProps);
       if(editForm)   {  
       if(editDimMerchantTier == "")
        {
            els.selectMerchantSwitch.prop("checked",true);
            els.selectMerchantSwitch.prop("disabled", true);
            els.merchantTierSection.hide();
            els.merchantSection.show(); 
        }
        else
        {
            els.selectMerchantSwitch.prop("checked",false);
            els.selectMerchantSwitch.prop("disabled", true);
            els.merchantTierDropDown.prop("disabled", true);
             els.merchantSection.hide();    
        }
    }
    else{
        els.selectMerchantSwitch.prop("checked",true);
        els.merchantTierSection.hide();
    }
      
    }

    function bindElements() {
        els.selectMerchantSwitch.on("change",changeSelectMerchantSwitch);
        let existingDimName=els.dimName.val();
        els.dimValidateClass.on('change', checkDimValidation);
        els.dimValidateClass.on("keydown", validateDimValue);
        //Method called on Click of Save
        els.dimSaveBtn.click(createPreventDefault(saveDimDivisor));
        els.retailersdropdown.on('blur', validateRetailer); 
        els.merchantTierDropDown.on('change', getDimMerchantTierValues);
        els.dimName.on('change', function(e){
            if($(this).val()!=existingDimName){
                validateDimName();
            }    
            else{
                $(els.dimNameExists.hide());
                $(els.dimNameError.hide());
            }        
        }); 
        els.dimName.on('keyup', function(e){
            if($(this).val()==''){
                els.dimNameError.hide();
              
            }
          }); 

    }
    
    function setupEditChecker(){
        EditChecker.bindNavigation();
        //Set the listeners for change on main form element
        EditChecker.bindChangeListener(els.dimFormElement);
        EditChecker.bindCancelButton(els.dimCancelBtn);
      
      }

      function changeSelectMerchantSwitch() {
         if($(this).prop("checked") == true)
         {
             els.merchantTierDropDown.prop('selectedIndex', -1).trigger("change");
             els.merchantSection.show();
             els.merchantTierSection.hide();
             els.merchantDiv.hide();
             els.dimNameExists.hide();

              $("#dimdivisor-name").val('');
              $(".dim-validate").each(function () {
                $(this).val('');
                     });
         }
         else
         {
            els.retailersdropdown.prop('selectedIndex', -1).trigger("change");
             els.merchantTierSection.show();
             els.merchantSection.hide();
             els.tierExistDiv.hide();
             els.dimNameExists.hide();

              $("#dimdivisor-name").val('');
                    $(".dim-validate").each(function () {
                         $(this).val('');
                          });
         }

    }

    function checkDimValidation(e) {
        e.preventDefault();
        let dimInputEle = $(this);
        let closetErrorEle = dimInputEle.parent().find('label');
        validateServiceLevelInput(closetErrorEle, dimInputEle.val());

    }

    function validateDimValue(e){
        var charCode = e.which || e.keyCode;
       if ((charCode >= 48 && charCode <= 57) || (charCode == 8 || charCode == 46) ||(charCode==9 || charCode==11) || (charCode >= 96 && charCode <= 105)) return true;
        e.preventDefault();
    }

    function validateServiceLevelInput(closetErrorEle, inputValue) {
        let pattern = /^[0-9]+$/;
        if (inputValue == '') {
            closetErrorEle.hide();
        } else if (!inputValue.match(pattern)) {
            closetErrorEle.show();
        } else if (inputValue < 100 || inputValue > 300) {
            closetErrorEle.show();
        } else {
            closetErrorEle.hide();
        }
    }

    function loadDropDowns() {
        
    }

    function generateModals() {

    }

    function renderDefaultDimUI(){
        //Logic to customize createEdit UI for default flow starts

        if(defaultDim !="" && defaultDim =="Y") {
           els.dimName.val(defDimName);
           els.dimName.prop('readonly', true);
        }else {
            els.dimName.prop('disabled', false);
        }
        //Logic to customize createEdit UI for default flow ends
    }
  
    function saveDimDivisor() {
        els.merchantTierDropDown.prop("disabled", false);
        if(els.dimFormElement.valid() == true && !els.dimFormElement.find('.q-sim-error').is(':visible') && !els.dimFormElement.find('.q-alert-red').is(':visible')) {
            const submitModalFlow = new SubmitModalFlow({
                confirmModalTitle: "Submit Dim Divisor",
                confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to update billing and accounting for selected merchants. </div>',
                confirmModalBtnText: "Submit",
                onConfirmClick: function () {
                 EditChecker.setPageClean();
                 submitModalFlow.showLoadingModal();
                 saveDimDivisor({url: saveDimDivisorUrl, success: success, error: error});
             
                    function saveDimDivisor({url, success, error}){
                        $.ajax({
                            data:  els.dimFormElement.serialize(),
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function success(response){
                        EditChecker.setPageClean();
                        submitModalFlow.showSuccessModal();
                        setTimeout(function() {
                            $('#dim-divisor-id').val(response.data);
                            els.dimFormElement.submit();
                         }, 3000);
                    }
                    function error(){
                        submitModalFlow.showFailureModal();
                    }
                }
              });
              submitModalFlow.init();
              submitModalFlow.showConfirmModal();
        }
    };

    function validateRetailer() {
        const selectedRetailerId= els.retailersdropdown.val(); 
        let data = 	{ 
	[`${portletNamespace}selectedRetailerId`]: JSON.stringify(selectedRetailerId)
            };
        
        if(!isNullOrUndefined(selectedRetailerId) && !isBlank(selectedRetailerId)){
            $.ajax({
            url: retailerCheckUrl,
            dataType:"JSON",
            type: 'POST',
            data: data,         
            success: function(data){
               if(data.response== true) {
                   $(els.merchantDiv.show());
                   els.dimFormElement.find('.merchant-names').empty();
                   els.dimFormElement.find('.merchant-names').append(data.merchantList);
                  
               }else{
                    $(els.merchantDiv.hide());
                 
               }  
            }  
         });
        }     
      }

      function getDimMerchantTierValues() {
        const selectedMerchantTier= els.merchantTierDropDown.val(); 
        let data = 	{ 
	                    [`${portletNamespace}selectedMerchantTier`]: selectedMerchantTier
                    };
        
        if(!isNullOrUndefined(selectedMerchantTier) && !isBlank(selectedMerchantTier)){
            $.ajax({
            url: marchantTierValuesUrl,
            dataType:"JSON",
            type: 'POST',
            data: data,         
            success: function(data){
               if(data.response== true) {
                    $(els.tierExistDiv.show());
                    els.dimFormElement.find('.tier-names').html(data.dimDivisorMechantValues.dimMerchantTier);
                    if(data.dimDivisorMechantValues != null)
                    {
                    $("#merchant-tier-flag").val("true");
                    $("#tier-dim-id").val(data.dimDivisorMechantValues.dimId);
                    setMerchantTierValuesTOJSP(data); 
                    }
               }else{
                        $(els.tierExistDiv.hide());
                        $("#merchant-tier-flag").val("false");
                        $("#dimdivisor-name").val('');
                        $(".dim-validate").each(function () {
                          $(this).val('');
                           });
               }  
            }  
         });
        }     
      }



      function setMerchantTierValuesTOJSP(data)
      {
        $("#dimdivisor-name").val(data.dimDivisorMechantValues.dimName);
        if(data.dimDivisorMechantValues.usServiceLevels != null)
        {
          data.dimDivisorMechantValues.usServiceLevels.forEach(function (marchantTierValue, index) {
            $("#usServiceLevels"+index).val(marchantTierValue.dmdDimValue);
          });
        }
         if(data.dimDivisorMechantValues.canadaServiceLevels != null)
        {
          data.dimDivisorMechantValues.canadaServiceLevels.forEach(function (marchantTierValue, index) {
            $("#canadaServiceLevels"+index).val(marchantTierValue.dmdDimValue);
          });
        }
           if(data.dimDivisorMechantValues.otherServiceLevels != null)
        {
          data.dimDivisorMechantValues.otherServiceLevels.forEach(function (marchantTierValue, index) {
            $("#otherServiceLevels"+index).val(marchantTierValue.dmdDimValue);
          });
        }

      }

      function clearValues()
      {
          
      }

      function validateDimName() {
        const dimName= els.dimName.val(); 
        const pattern = /^[a-zA-Z0-9\u00C0-\u00ff\s-_',`~!@+=#$%^&*";<>.?:\?\/\[\]!\./\\\(\)\{\}]+$/;
        els.dimNameError.hide();
        if(!dimName.match(pattern) && !dimName == '') {
            els.dimNameError.show();
            return false;
        }     
        let data = 	{ 
			[`${portletNamespace}dimName`]: dimName
            };
        
        if(!isNullOrUndefined(dimName) && !isBlank(dimName)){
            $.ajax({
            url: dimNameCheckUrl,
            dataType:"JSON",
            type: 'POST',
            data: data,         
            success: function(data){
               if(data.response== true) {
                   $(els.dimNameExists.show());                 
                   return false;
               }else{
                    $(els.dimNameExists.hide());
                    return true;
               }  
            }  
         });
        }     
      }

    init();

    
  
}); 


// WEBPACK FOOTER //
// ./src/pages/dimdivisor/createEditDimDivisor.js